<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
    />
    <circle
      cx="12"
      cy="12"
      r="5"
    />
    <path d="M12 8.5v7M9.8 10.2h4.4M9.8 13.8h4.4" />
  </svg>
</template>
